// Main JS goes here
var base = {
	init: function () {
		var self = this;
		this.$page = $('html');

		// document.addEventListener('click', e => {
		// 	if (e.target && e.target.matches('[data-product] [data-add-to-cart]')) {
		// 		self.minicart($(e.target.closest('form')))
		// 	}
		// })

		this.free_shipping = {
			amount: (typeof freeShipping !== 'undefined') ? parseFloat(freeShipping.amount) : 0,
			subtotal: 0
		}

		this.headerCartCount = this.$page.find('[data-header-cart-count]');
		this.currency = Shopify.currency.active;

		// Setup localstorage for swatches
		this.swatcheskey = 'swatches_' + this.currency
		if(!localStorage[this.swatcheskey]){
			localStorage.setItem(this.swatcheskey, JSON.stringify({'items': {}, 'timestamp': new Date().getTime()}));
		} else {
			// check storage timestamp
			var storage = JSON.parse(localStorage[this.swatcheskey]);
			if(storage.timestamp < new Date().getTime() - (1000 * 60 * 90)){
				localStorage.removeItem(this.swatcheskey);
				localStorage.setItem(this.swatcheskey, JSON.stringify({'items': {}, 'timestamp': new Date().getTime()}));
			}
		}

		// Get user agent info and set as html data-attributes
		// This is for custom styling/bug fixes for specific browser versions
		var el = document.documentElement,
			userAgent = navigator.userAgent;

		el.setAttribute('data-useragent', userAgent);
		el.setAttribute('data-platform', navigator.platform);

		// Fix IOS click delays
		FastClick.attach(document.body);

		// Test for css hover
		Modernizr.addTest('mobile', function () {
			return navigator.userAgent.match(/(iPad|iPhone|iPod|Android|webOS|BlackBerry|IEMobile|Opera Mini)/g);
		});

		// $(document).on('mouseover', '[data-product]', e => {
		// 	$(e.target.closest('[data-product]')).addClass('product-quick--active')
		// 	console.log('mouseover')
		// }).on('mouseleave', '[data-product]', e => {
		// 	$(e.target.closest('[data-product]')).removeClass('product-quick--active')
		// 	console.log('mouseleave')
		// })


		$(document).on('mouseover', '[data-product]', e => {
			$(e.currentTarget).addClass('product-quick--active')
			// console.log('mouseover')
		}).on('mouseleave', '[data-product]', e => {
			$(e.currentTarget).removeClass('product-quick--active')
			// console.log('mouseleave')
		})

		// Removes product size variants grid when mouse leaves
		// $(document).on('mouseleave', '[data-product]', e => {
		// 	$(e.target).removeClass('product-quick--active')
		// 	console.log('mouseleave')
		// })


		// PLP Quick Add Button toggle class
		// $(document).on('click', '[data-product-add-quick]', e => {
		// 	$(e.target).closest('.product__item').toggleClass('product-quick--active')
		// 	// $('.product__quick-btn').css('opacity', '0')
		// })

		// Quickshop clicks
		this.quickshopTemplate = $('[data-quickshop-template]')
		this.quickshops = {};
		this.quickshopEvents();

		// Mini Cart Actions
		this.sidebarTrigger();

		this.$page.on('click', '[data-toggle-menu]', function() {
	      $('body').toggleClass('menu-active')

	      setTimeout(function() {
	        $('[data-submenu]').removeClass('submenu--active')
	      }, 300)
		});

		// Sticky Header
		$(window).on('resize scroll', function () {
			$('[data-header]').each(function () {
				var header = $(this),
					body = $('body'),
					html = $('html'),
					content = header.find('[data-header-content]'),
					contentOffset = content.offset().top,
					windowTop = $(window).scrollTop(),
					position = Math.ceil(contentOffset - windowTop),
					panel = header.find('[data-header-promo-banner]'),
					panelHeight = panel.length ? panel.outerHeight() : 0,
					headerHeight = header.outerHeight();

				// Scroll Down
				if (position <= 0) {
					body.css('margin-top', headerHeight);
					html.addClass('header-fixed');
					header.css('margin-top', -panelHeight);
				}

				// Scroll Up
				if (windowTop <= panelHeight) {
					body.css('margin-top', '');
					html.removeClass('header-fixed');
					header.css('margin-top', '');
				}
			});
		}).resize();

    const fixFlickity = function () {
      let touchingCarousel = false
      let touchStartCoords

      document.body.addEventListener('touchstart', (e) => {
        if (e.target.closest('.flickity-slider')) {
          touchingCarousel = true
        } else {
          touchingCarousel = false
          return
        }

        touchStartCoords = {
          x: e.touches[0].pageX,
          y: e.touches[0].pageY
        }
      })

      document.body.addEventListener('touchmove', (e) => {
        if (!(touchingCarousel && e.cancelable)) {
          return
        }

        const moveVector = {
          x: e.touches[0].pageX - touchStartCoords.x,
          y: e.touches[0].pageY - touchStartCoords.y
        }

        if (Math.abs(moveVector.x) > 7) { e.preventDefault() }
      }, { passive: false })
    }

    fixFlickity()

		$('html').on('touchstart', 'body.submenu--hovered', function(e) {
		  if ($(this).is('[data-submenu].hover') || $(e.target).closest('[data-submenu].hover').length > 0) {
		    return
		  } else {
			$('[data-submenu].hover').removeClass('hover')
			$('body').removeClass('submenu--hovered')
		  }
		});

		this.$page.on('touchstart', '[data-submenu]', function() {
		  if (matchMedia('screen and (min-width: 1200px)').matches) {
			$('body').addClass('submenu--hovered')
		    $(this).addClass('hover')
		  }
		});

		// this.$page.on('submit', '[data-pairs-with-form]', function(e) {
		// 	e.preventDefault()

		// 	self.addToMiniCart($(this))
		// })

		// this.$page.on('submit', '[data-product-detail-form]', function(e) {
		// 	e.preventDefault();

		// 	self.addToMiniCart($(this))
		// });

		this.$page.on('submit', '[data-pairs-with-form]', function(e) {
			e.preventDefault()
			self.addToMiniCart($(this))
		})

		this.$page.on('submit', '[data-product-detail-form]', function(e) {
			e.preventDefault();
			self.addToMiniCart($(this))
		});

		this.$page.on('click', '[data-product] [data-add-to-cart]', function(e) {
			e.preventDefault();
			const $form = $(this).closest('form')
			$form.find('[name="id"]').val($(this).data('product-add-to-cart'))
			self.addToMiniCart($form)
		});


		// Ajax update items quantity in cart
		this.$page.on('click', '[data-minicart-remove], [data-minicart-update-quantity]', function(e) {
			e.preventDefault();

			var $updateEl = $(this),
				$updateElContainer = $updateEl.closest('[data-minicart-item-variant-id]'),
				$inputQuantity = $updateElContainer.find('[data-input-quantity]'),
				$itemQuantity = $updateElContainer.find('[data-minicart-item-count]'),
				itemPrice = $updateElContainer.find('[data-minicart-item-price]').data('minicart-item-price'),
				currentAmount = parseFloat($inputQuantity.val()),
				isRemoveButton = $updateEl.is('[data-minicart-remove]'),
				changeAmount = parseFloat($updateEl.data('minicart-update-quantity')),
				quantity = isRemoveButton ? 0 : currentAmount + changeAmount;

			// They clicked the incrementor below 1, so remove the item
			if (currentAmount === 1 && changeAmount === -1) {
				$.post('/cart/change.js', {
					line: $updateElContainer.index() + 1,
					quantity: 0
				}, null, 'json');

				$updateElContainer.remove();

				$inputQuantity.val(quantity);
				$itemQuantity.text(quantity);
				$updateElContainer.attr('data-minicart-item-total', quantity * itemPrice);

				self.setCartCount();
				self.setSubtotal();
				self.toggleFreeShippingMessage();

				if (document.querySelectorAll('[data-minicart-item-total]').length < 1) {
					$('[data-minicart-full]').addClass('hidden')
					$('[data-minicart-empty]').removeClass('hidden')
				}
				//bongo update
				$('[data-bongo-item-variant-id="' + $updateElContainer.data('minicart-item-variant-id') + '"]').val(0);
				return false;
			}

			$.post('/cart/change.js', {
				line: $updateElContainer.index() + 1,
				quantity: quantity
			}, null, 'json');

			//bongo update
			$('[data-bongo-item-variant-id="' + $updateElContainer.data('minicart-item-variant-id') + '"]').val(quantity);

			if (isRemoveButton) {
				if (document.querySelectorAll('[data-minicart-item-total]').length > 1) {
					$updateElContainer.slideToggle(function() {
						$updateElContainer.remove();
					});
				} else {
					$('[data-sidebar="cart"]')[0].click();
					$('[data-minicart-full]').addClass('hidden')
					$('[data-minicart-empty]').removeClass('hidden')
					$updateElContainer.remove();
				}
			}

			$inputQuantity.val(quantity);
			$itemQuantity.text(quantity);
			$updateElContainer.attr('data-minicart-item-total', quantity * itemPrice);

			self.setCartCount();
			self.setSubtotal();
			self.toggleFreeShippingMessage();

			return false;
		});

		// Protect _blank attacks
		$('a[target=_blank]').each(function () {
			var rel = $(this).attr('rel');

			if (typeof rel === typeof undefined || rel === false) {
				$(this).attr('rel', 'noopener noreferrer');
			} else {
				rel = rel.replace(/noopener/g, '').replace(/noreferrer/g, '').replace(/^\s+|\s+$/gm, '');
				var value = rel.length ? ' noopener noreferrer' : 'noopener noreferrer';
				$(this).attr('rel', rel + value);
			}
		});

		// Password protection page
		$('a[href="#Login"]').on('click', function () {
			$('html').toggleClass('login-active');
		});

		if (window.location.hash) {
			var hash = window.location.hash;

			if (hash == '#Login') {
				$('html').addClass('login-active');
			}
		}

		var errors = $('#Login .errors');
		if (errors && errors.length) {
			$('html').addClass('login-active');
		}
		$(window).scroll(function() {
			if($(window).scrollTop() + $(window).height() > $(document).height() - 100) {
				$('.shop-social .fs-next-button').click();
			}
		});


		// Rotating header message
		$('[data-header-message]').each(function () {
			var message = $(this).find('li'),
				activeClass = 'header-message__item--active';

			message.first().addClass(activeClass);

			setInterval(function () {
				var active = message.filter('.' + activeClass).first(),
					next = active.next('li').length ? active.next('li') : message.first();

				active.removeClass(activeClass);

				setTimeout(function () {
					next.addClass(activeClass);
				}, 300);
			}, 5000);
		});

		// Nav tools hover
		$('[data-hover]').each(function () {
			var el = $(this),
				val = el.data('hover');

			el.on('mouseenter', function () {
				el.addClass('hover');
			});

			el.on('mouseleave', function () {
				el.removeClass('hover');
			});

			if (val != 'cart') {
				el.on('touchstart', function () {
					el.toggleClass('hover');
				});
			}
		});

    Flickity.prototype._touchActionValue = 'pan-y pinch-zoom';

		// Main Hero
		const $mainHero = $('[data-hero-slider]');

		$mainHero.flickity({
			autoPlay: 6000,
			contain: true,
			imagesLoaded: true,
			pageDots: true,
			wrapAround: true
		});

		// lazy load videos in hero, pause when not selected
		$mainHero.on('settle.flickity', function(event, index) {
			const $nextSlideVideo = $mainHero.find('.is-selected + .hero__item--video');
			const $playingVideo = $mainHero.find('.video--playing')

			if ($playingVideo.length > 0) {
				$playingVideo.removeClass('video--playing')
				$playingVideo[0].pause();
			}

			if ($nextSlideVideo.length > 0) {
				const $nextVideo = $nextSlideVideo.find('video[src="#"]');
				if ($nextVideo) $nextVideo.attr('src', $nextVideo.data('src'));
			}

			// lazy load this slides video if its not already loaded
			const $selectedVideoContainer = $mainHero.find('.hero__item--video.is-selected');

			if ($selectedVideoContainer.length > 0) {
				const $unloadedVideo = $selectedVideoContainer.find('video[src="#"]:not(.lazy)');

				if ($unloadedVideo.length > 0) {
					$unloadedVideo.attr('src', $unloadedVideo.data('src'));
				}

				const $video = $selectedVideoContainer.find('video');

				if (!$video[0].paused) return;

				$video.addClass('video--playing');
				$video[0].play();
			}
		});

		// Featured Item Videos: play when entering viewport, pause when leaving
		const $featuredItemVideo = document.querySelector('[data-featured-item-video]');

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) {
					if ($featuredItemVideo.playing) $featuredItemVideo.pause()
				} else {
					if ($featuredItemVideo.classList.contains('lazy-video') > -1) {
						$featuredItemVideo.src = $featuredItemVideo.dataset.src
						$featuredItemVideo.classList.remove('lazy-video')
						$featuredItemVideo.classList.add('loaded')
					}

					$featuredItemVideo.play();
				}
			});
		}, {});

		if ($featuredItemVideo !== null) {
			observer.observe($featuredItemVideo);
		}

		document.addEventListener('keyup', (event) => {
			if (event.target.matches('.dot')) {
				if (event.key === 'Enter' || event.keyCode === 13) {
					var index = $(event.target).index();
					$mainHero.flickity('select', index);
				}
			}
		});

		// Featured Lookbook
		$('[data-featured-lookbook-slider]').each(function () {
			var body = $('body'),
				slider = $(this);

			body.css({ 'overflow-y': 'scroll' });

			slider.on('ready.flickity', function () {
				body.css({ 'overflow-y': '' });
			});

			slider.flickity({
				// groupCells: true,
				imagesLoaded: true,
				initialIndex: 1,
				pageDots: false,
				prevNextButtons: false,
				wrapAround: true,
				adaptiveHeight: true,
				lazyLoad: true
			});
		});

		// Featured Products
		$('[data-featured-products]').each(function () {
			var body = $('body'),
				slider = $(this);

			body.css({ 'overflow-y': 'scroll' });

			slider.on('ready.flickity', function () {
				body.css({ 'overflow-y': '' });
			});

			slider.flickity({
				// groupCells: true,
				adaptiveHeight: true,
				cellAlign: 'left',
				contain: true,
				imagesLoaded: true,
				pageDots: false,
				wrapAround: true
			});

			setTimeout(function() {
				slider.flickity('resize')
			}, 200);
		});

		var zoomDebounce;
		$(window).on('resize', function () {
			clearTimeout(zoomDebounce);
			zoomDebounce = setTimeout(function () {
				self.productDetailZoom();
			}, 500);
		}).resize();

		// Populate Related Items
		this.productDetailRelatedItems();

		// Product Detail Image Carousel
		this.productDetailImageCarousel();

		// Product Detail Variants (Size & Color)
		this.productUpdateInfo();

		this.productHoverVideos()

		// Product Detail Related Products
		$('[data-related-products]').each(function () {

		});

		this.productVariants($('body'));

		// Newsletter Section Display
		$('[data-newsletter]').each(function () {
			var container = $(this);

			if (!Cookies.get('newsletter')) {
				container.addClass('newsletter--active');
			}
		});

		// Newsletter Section Close
		$(document).on('click', '[data-newsletter-close]', function () {
			var button = $(this),
				container = button.closest('[data-newsletter]');

			container.slideUp();
			Cookies.set('newsletter', 1, { path: '' });
		});

		// Newsletter Section Submit
		$('[data-newsletter] .contact-form').each(function () {
			var form = $(this),
				alert = form.find('[data-newsletter-alert]'),
				inputEmail = form.find('[data-newsletter-input]'),
				inputFail = form.find('input[name="fail"]');

			form.on('submit', function () {
				if (inputFail.val() != 1) {
					if (inputEmail.val() != '') {
						$.ajax({
							type: form.attr('method'),
							url: form.attr('action'),
							data: form.serialize(),
							success: function (data) {
								alert.addClass('newsletter-message--active');
								Cookies.set('newsletter', 1, { 'expires': 365, path: '' });
							},
							error: function(data) {
								inputFail.val(1);
								form.submit();
							}
						});
					}
					return false;
				}
			});
		});

		// Newsletter Footer
		$('[data-footer-newsletter] .contact-form').each(function () {
			var form = $(this),
				alert = form.find('[data-footer-newsletter-alert]'),
				inputEmail = form.find('[data-footer-newsletter-input]'),
				inputFail = form.find('input[name="fail"]');

			form.on('submit', function () {
				if (inputFail.val() != 1) {
					if (inputEmail.val() != '') {
						$.ajax({
							type: form.attr('method'),
							url: form.attr('action'),
							data: form.serialize(),
							success: function (data) {
								alert.addClass('footer-newsletter-message--active');
							},
							error: function (data) {
								inputFail.val(1);
								form.submit();
							}
						});
					}
					return false;
				}
			});
		});

		// Smooth Scroll
		var scrollToAnchor = function (hash) {
			var target = $(hash),
				offset = window.matchMedia('(max-width: 1199px)').matches ? 77 : 80;

			target = target.length ? target : $('[name=' + hash.slice(1) + ']');

			if (target.length) {
				$('html, body').animate({
					scrollTop: target.offset().top - offset
				}, 750);
			}
		};

		if (window.location.hash) {
			scrollToAnchor(window.location.hash);
		}

		$(document).on('click', 'a[href^=\\#]:not([href=\\#])', function () {
			if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') || location.hostname == this.hostname) {
				scrollToAnchor(this.hash);
				return false;
			}
		});

		// Tabs
		$('[data-tabs]').each(function () {
			var el = $(this),
				contentNavTab = el.find('[data-content-nav-tab]');

			if (!el.find('[data-tab]').hasClass('active') && !el.find('[data-tab]:first-of-type').hasClass('active')) {
				if (typeof (contentNavTab) !== 'undefined') {
					contentNavTab.first().addClass('active');
				}
				el.find('[data-nav-tab]').first().addClass('active');
				el.find('[data-tab]').first().addClass('active');
			}
		});

		// Toggle tabs with nav button clicks
		$('[data-nav-tab], [data-content-nav-tab]').on('click', function () {
			var el = $(this),
				active = typeof (el.data('content-nav-tab')) !== 'undefined' ? el.data('content-nav-tab') : el.data('nav-tab'),
				container = el.closest('[data-tabs]'),
				content = container.find('[data-tab="' + active + '"]'),
				contentNavTab = container.find('[data-content-nav-tab="' + active + '"]'),
				navTab = container.find('[data-nav-tab="' + active + '"]');

			// Content
			content.addClass('active').siblings('[data-tab]').removeClass('active');

			// Nav content tab (Optional)
			if (typeof (contentNavTab) !== 'undefined') {
				contentNavTab.addClass('active').siblings('[data-content-nav-tab]').removeClass('active');

				if (self.getBreakpoint() < 768) {
					$('html, body').animate({ scrollTop: contentNavTab.offset().top - 20 }, 0);
				}
			}

			// Nav tab
			navTab.addClass('active').siblings('[data-nav-tab]').removeClass('active');
		});

		// Toggle
		$('[data-toggle-class]').on('click', function () {
			var el = $(this),
					className = el.data('toggle-class'),
					// You can override by setting data-toggle-class-on='any-element'
					target = typeof (el.data('toggle-class-on')) === 'undefined' ? $('html') : $(el.data('toggle-class-on')),
					toggleMaxWidth = typeof ($(this).data('toggle-max-width')) !== 'undefined' ? $(this).data('toggle-max-width') : null;

			if (toggleMaxWidth !== null && self.getBreakpoint() < toggleMaxWidth || toggleMaxWidth === null) {
				// Toggle the class
				target.toggleClass(className);
				return false;
			}
		});

		$('[data-toggle-transition]').on('click', function () {
			var el = $(this),
				className = el.data('toggle-transition').class,
				duration = el.data('toggle-transition').duration,
				target = $('html');

			target.addClass(className);

			setTimeout(function () {
				target.removeClass(className);
			}, duration);
		});

		$('[data-toggle]').on('click', function () {
			var toggleMaxWidth = typeof ($(this).data('toggle-max-width')) !== 'undefined' ? $(this).data('toggle-max-width') : null;

			// Toggle if under the data=toggle-max-width, or if there is no data-toggle-max-width set
			if (toggleMaxWidth !== null && self.getBreakpoint() < toggleMaxWidth || toggleMaxWidth === null) {
				self.dataToggle($(this));
				return false;
			}
		});

		$('[data-modal]').on('click', function (e) {
			if (e.target.dataset.pageLink == 'true') {
				return
			}

			var modalType = $(this).data().modal

			if (modalType) {
				var modal = $(this).find('.' + modalType)

				modal.addClass('visible')

				// Flickity in modals have known bug of not giving height to the carousel
				// until a resize. This is the fix
				if (modalType === 'press-modal') {
					var flkty = Flickity.data( $('.press-modal__carousel')[0] )

					flkty.resize()
				}
			}
		})

		$('[data-modal-close]').on('click', function () {
			var modal = $(this).closest('[data-modal]')

			modal.removeClass('visible')

			return false
		})

		// Lookbook Modal Product Toggle
		$('[data-lookbook-nav]').on('click', function () {
			var number = $(this).data().lookbookNav
			var product = $('[data-lookbook-product='+ number + ']')

			$('.lookbook-modal.visible [data-lookbook-nav]').removeClass('active')
			$(this).addClass('active')

			$('[data-lookbook-product]').removeClass('product-detail-lookbook--active')

			setTimeout(() => {
				product.addClass('product-detail-lookbook--active')
			}, 500)
		})

		// Collection Filter Toggle
		$('[data-collection-filter-toggle]').on('click', function () {
			$(this).closest('.filter-group').toggleClass('active-toggle')
		})

		$('[data-sorter]').on('click', function(e) {
			e.preventDefault()

			if (window.innerWidth <= 1024) {
				$(this).toggleClass('active')
			}
		})

		$('[data-sorter] a').on('click', function(e) {
			e.stopPropagation();
		})

		// Tooltips for the Color and Coverage filters
		setTimeout(function() {
			if ($('#shopify-section-collection').length > 0) {
				$('.collection-name a').removeAttr('title')

				tippy('.product-detail-color__tooltip--color', {
					arrow: true,
					arrowType: 'sharp',
					size: 'large',
					duration: 50,
					animation: 'scale',
					sticky: true,
					appendTo: document.querySelector('.nav-color '),
					popperOptions: {
						modifiers: {
							preventOverflow: {
								enabled: false
							},
							hide: {
								enabled: false
							}
						}
					}

				})

				tippy('.product-detail-color__tooltip--coverage', {
					arrow: true,
					arrowType: 'sharp',
					size: 'large',
					duration: 50,
					animation: 'scale',
					sticky: true,
					appendTo: document.querySelector('.nav-coverage '),
					popperOptions: {
						modifiers: {
							preventOverflow: {
								enabled: false
							},
							hide: {
								enabled: false
							}
						}
					}

				})
			}
		}, 500);

		// Load the size chart data from the Size Guide page on PDP page load
		if ($('.product-detail-size-chart').length > 0) {
			$('.product-detail-size-chart').load( window.location.origin + '/pages/size-guide #size-guide');
		}

		// Ajax pagination
		$('.collection-wall__shop-all').on('click', function(e){
			e.preventDefault();
			var endlessScroll = new Ajaxinate({
				container: '.product__list',
				pagination: '.paginate-ajax',
				offset: 400,
				callback: base.bindPLPElements
			});

			$('.collection-wall__shop-all').hide();
			$('.pagination--products').hide();

			$('.paginate-ajax').css('display', 'flex');

			endlessScroll.checkIfPaginationInView();
		});

		$('script[data-feed-id="beachbunnyswimwear"]').on('foursixtyPageRendered', function(){
			if($('.fs-entry-container').length <= 0){
				$('.shopify-section--featured-social').hide();
			}
		});

		//Bind swatches
		self.productSwatches();

		(function($){
			$(window).on('load', function() {
				if ($('.mCustomScrollbarContainer').length > 0) {
					$('.mCustomScrollbarContainer').mCustomScrollbar({
						axis: 'x',
						theme: 'dark',
						setWidth: true,
						mouseWheel: {
							enable: true,
							axis: 'x'
						},
						advanced: {
						updateOnContentResize: true
						},
					});
				}
			});
		})(jQuery);


		// this.navAccessibility()
	},

	// Product Detail Zoom
	productDetailZoom: function () {
		$('[data-product-detail-image-zoom] [data-product-detail-zoom]').each(function () {
			var el = $(this),
				image = el.data('product-detail-zoom');

			if (matchMedia('screen and (min-width: 768px)').matches) {
				if (!el.hasClass('is-zoom')) {
					el.zoom({
						on: 'click',
						url: image,
						callback: function () {
							el.addClass('is-zoom');
						},
						onZoomIn: function () {
							// unzoom other images
							const zoomedSibling = el.parent().siblings().find('[data-product-detail-zoom]').eq(0);
							if (zoomedSibling.length < 1) return
							zoomedSibling.removeClass('is-zoom');
							zoomedSibling.trigger('zoom.destroy');
						}
					});
				}
			} else {
				if (el.hasClass('is-zoom')) {
					el.removeClass('is-zoom');
					el.trigger('zoom.destroy');
				}
			}
		});
	},

	bindPLPElements: function() {
		base.productUpdateInfo();
		base.productSwatches();
		base.productHoverVideos()
	},

	productSwatches: function () {
		var storageSwatches = JSON.parse(localStorage[this.swatcheskey]);
		// Swatches
		var searchHandles = $.uniqueSort($('[data-product-swatch-handle]').map(function(){
			return $(this).data('product-swatch-handle')
		}).get());

		searchHandles.forEach(function(value) {
			var productTile = $('[data-handle="' + value + '"]'),
				swatchTile = $('[data-product-swatch-handle="' + value + '"]'),
				template = '<a href="${url}" \
					class="product-swatches__link product-swatches__link--tile"\
				 	data-product-image="${featured_image}" \
				 	data-product-image-alt="${featured_image_alt}" \
					data-color="${color}"\
					data-price="${price}"\
					data-compared-at-price="${compared_at_price}"\
					data-product-id="${product_id}"\
					aria-label="${color}">\
					 <span class="product-detail-color__swatch" style="background-color: ${color_code}; background-image: url(${color_image})"></span></a>';

			$.template('colorTemplate', template);

			swatchTile.each(function(){
				var item = $(this);

				if(storageSwatches.items.hasOwnProperty(value)){
					var localSwatch = storageSwatches.items[value];
					if(localSwatch != ''){
						if (localSwatch.hasOwnProperty('color_code')) localSwatch.color_code = localSwatch.color_code.replace(/ /g, '').toLowerCase()
						item.removeClass('product-swatches__item--hidden').html($.tmpl( "colorTemplate", localSwatch ));
					}
				} else {
					if ($('[data-handle="' + value + '"]').length > 0) {
						var productMeta = {
							'url': productTile.data('url'),
							'color': productTile.data('color'),
							'color_code': productTile.data('color-code').replace(/ /g, '').toLowerCase(),
							'color_image': productTile.data('color-image'),
							'featured_image': productTile.data('product-image'),
							'featured_image_alt': productTile.data('product-image-alt'),
							'current_color': item.parent().parent().parent().parent().data('color'),
							'price': productTile.data('price'),
							'compared_at_price': productTile.data('compared-at-price'),
							'product_id': productTile.data('product')
						}

						item.removeClass('product-swatches__item--hidden').html($.tmpl( "colorTemplate", productMeta ));
						storageSwatches.items[value] = productMeta;
						localStorage.setItem(this.swatcheskey, JSON.stringify(storageSwatches));
					} else {
						$.ajax({
							type: 'GET',
							url: '/products/' + value + '?view=meta.json',
							success: function (result, textStatus, xhr) {
								try {
									var productMeta = JSON.parse(result);
								} catch (e) {
									return;
								}
								if (productMeta.hasOwnProperty('color_code')) productMeta.color_code = productMeta.color_code.replace(/ /g, '').toLowerCase()
								storageSwatches.items[value] = productMeta;
								localStorage.setItem(this.swatcheskey, JSON.stringify(storageSwatches));
								swatchTile.each(function(){
									var item = $(this);

									item.removeClass('product-swatches__item--hidden').html($.tmpl( "colorTemplate", productMeta ));
								});
							},
							error: function (xhr, ajaxOptions, thrownError) {
								storageSwatches.items[value] = '';
								localStorage.setItem(this.swatcheskey, JSON.stringify(storageSwatches));
							}
						})
					}
				}
			})
		});

	},

	productDetailRelatedItems: function() {
		const productJson = $('[data-product-json]')

		if (productJson.length === 0) return

		const self = this
		const product = JSON.parse(productJson.html())

		$('.pairs-with').each(function(){
			var el = $(this);

			$.ajax({
				type: 'GET',
				url: '/products/' + product.handle + '?view=pairs-with',
				success: function (result, textStatus, xhr) {
					el.append(result);
					self.productSwatches();
					self.productVariants(el);
					setTimeout(() => {
						// Set all the pairs with products to matching color of main product
						var selectedColor = $('.product-detail-form .product-detail-color__item.active').data('swatch-current-color');
						$('.pairs-with .product-detail-color__item a[data-color="' + selectedColor + '"]').trigger('click');
					}, 1100);
				}
			});
		});

		$('[data-wear-it-with]').each(function(){
			const $item = $(this)
			const $container = $item.closest('[data-section-id]')
			const el = $item.find('[data-related-products]');

			$.ajax({
				type: 'GET',
				url: '/products/' + product.handle + '?view=wear-it-with',
				success: function (result, textStatus, xhr) {
					el.html(result);

					if (el.find('> *').length > 0) {
						self.productSwatches();
						self.productVariants(el);
						self.productDetailRelatedSlider(el);
					} else {
						$container.hide()
					}
				}
			});
		});

		$('[data-also-like]').each(function(){
			const $item = $(this)
			const $container = $item.closest('[data-section-id]')
			const el = $item.find('[data-related-products]')

			$.ajax({
				type: 'GET',
				url: '/products/' + product.handle + '?view=also-like',
				success: function (result, textStatus, xhr) {
					el.html(result);

					if (el.find('> *').length > 0) {
						self.productSwatches();
						self.productVariants(el);
						self.productDetailRelatedSlider(el);
					} else {
						$container.hide()
					}
				}
			});
		});
	},

	productDetailRelatedSlider: function(element) {

    var body = $('body'),
			slider = $(element),
			slidesCount = slider.find('.product__item').length,
			slider3cols = window.matchMedia('(min-width: 768px) and (max-width: 1599px)').matches,
			slider4cols = window.matchMedia('(min-width: 1600px)').matches,
			dragThreshold = window.pdpRelatedDragThreshold || 1

		body.css({ 'overflow-y': 'scroll' });

		slider.on('ready.flickity', function () {
			body.css({ 'overflow-y': '' });
		});

		slider.flickity({
			// groupCells: true,
			adaptiveHeight: true,
			cellAlign: 'left',
			contain: true,
			dragThreshold: dragThreshold,
			imagesLoaded: true,
			pageDots: false,
			prevNextButtons: (slider4cols && slidesCount > 4 || slider3cols && slidesCount > 3 || window.innerWidth <= 414) ? true : false,
			wrapAround: (slider4cols && slidesCount < 5 || slider3cols && slidesCount < 4) ? false : true
		});

		window.lazy.update()
	},

	productDetailImageCarousel: function () {
    // var dots = typeof dots !== undefined ? dots : false;
		$('[data-product-detail-image-display]').each(function () {
      var body = $('body'),
      slider = $(this),
      container = slider.closest('[data-product-detail]');
      slider.touchActionValue="pan-y pinch-zoom";

			body.css({ 'overflow-y': 'scroll' });

			slider.on('change.flickity', function (event, index) {
				var thumbnail = container.find('[data-product-detail-thumb-color]');
				thumbnail.eq(index).addClass('product-detail-thumb__item--active').siblings().removeClass('product-detail-thumb__item--active');
			});

			slider.on('settle.flickity', function(event, index) {
				// lazy load next two slides videos
				const $nextSlideVideo = $('.is-selected + .product-detail-image__item--video');
				const $nextNextSlideVideo = $('.is-selected + .product-detail-image__item + .product-detail-image__item--video');

				if ($nextSlideVideo.length > 0) {
					const $nextVideo = $nextSlideVideo.find('video[data-src]:not([src])');
					if ($nextVideo) $nextVideo.attr('src', $nextVideo.data('src'));
				}

				if ($nextNextSlideVideo.length > 0) {
					const $nextNextVideo = $nextNextSlideVideo.find('video[data-src]:not([src])');
					if ($nextNextVideo) $nextNextVideo.attr('src', $nextNextVideo.data('src'));
				}

				// lazy load this slides video if its not already loaded
				let $selectedVideo = $('.product-detail-image__item--video.is-selected');

				if (!$selectedVideo[0]) $selectedVideo = $('.product-detail-image__item.is-selected + .product-detail-image__item--video:last-child:nth-of-type(even)');

				if ($selectedVideo.length > 0) {
					const $video = $selectedVideo.find('video[data-src]:not([src])');

					if ($selectedVideo.find('video[data-src]:not([src])').length > 0) {
						$selectedVideo.find('video[data-src]:not([src])').attr('src', $video.data('src'))
					}

					if ($selectedVideo.find('video')) $selectedVideo.find('video')[0].play();

					$('.product-detail-zoom-disclaimer').hide();
				} else {
					$('.product-detail-zoom-disclaimer').show();
				}
			})

			slider.on('ready.flickity', function () {
				var image = slider.find('.product-detail-image__image:first'),
					viewport = slider.find('.flickity-viewport');

				body.css({ 'overflow-y': '' });

				slider.removeClass('product-detail-image--loading');

				setTimeout(function () {
					slider.css({ 'height': '' });

					if (image.height() != viewport.height()) {
						viewport.height(image.height());
					}
        }, 500);

        // mobile zoom
        const allSlidesWrap = document.querySelector('[data-product-detail-image-display]')
        const allSlides = document.querySelectorAll('.product-detail-image__zoom')
        const mobileZoomClose = document.querySelector('[data-mobile-zoom-close]')
        for (const slide of allSlides) {
          slide.addEventListener('click', () => {
            if (window.innerWidth <= 414) {
              window.scroll(0,0)
              document.body.classList.add('mobile-zoom-active')
            }
          })
        }

				if (mobileZoomClose) {
					mobileZoomClose.addEventListener('click', () => {
						window.scroll(0,0)
						document.body.classList.remove('mobile-zoom-active')
					})
				}
			});

			var options = {
				cellAlign: 'left',
				contain: true,
				draggable: true,
				pageDots: slider.closest('.product__item').length > 0,
				imagesLoaded: true,
				lazyLoad: 2,
			};

			if (matchMedia('screen and (min-width: 768px)').matches) {
				options.draggable = false;
			}

			slider.flickity(options);
		});
	},

	productUpdateInfo: function () {
		var self = this;

		$('[data-product-variant-type]').each(function () {
			var el = $(this),
				container = el.closest('[data-product-detail]'),
				type = el.data('product-variant-type'),
				select = container.find('select[data-index-type="' + type + '"]'),
				selectedSize = container.find('input[name="selected-size"]'),
				value;

			// Update PLP product image on color swatch change
			var updatePDPMainImage = function (self) {
				var color = $(self).data('color'),
						variantImages = $(self).closest('.product-container').find('.product-detail-image--hidden'),
						images = variantImages.find('[data-product-detail-image-color="' + color + '"]').slice(0, 2),
						// main = $(images[0]).find('img').attr('src'),
						// alt = $(images[1]).find('img').attr('src'),
						main = $(self).data('product-image'),
						alt = $(self).data('product-image-alt'),
						imageContainer = $(self).closest('.product-detail-color').prev();

				imageContainer.find('.product__image--main').css('background-image', 'url("' + main + '")')
				imageContainer.find('.product__image--alt').css('background-image', 'url("' + alt + '")')
			};

			// Update images, carousel, and zoom
			var updateImages = function (images, color, accentuate) {
				var videoMp4

				if (accentuate.hasOwnProperty('product_video_mp4')) {
					videoMp4 = accentuate.product_video_mp4
				}

				var display = container.find('[data-product-detail-image-display]')
				var title = container.find('[data-product-variant-title-color]')
				var image_template = '<div class="product-detail-image__item" data-product-detail-image-color="${alt}">\
											<div class="product-detail-image__zoom" data-product-detail-zoom="${zoom_image}">\
												<img src="${image}" class="product-detail-image__image" alt="${alt}">\
											</div>\
										</div>'

				$.template('imageTemplate', image_template);

				display.css({ 'height': display.outerHeight() });
				display.flickity('destroy');
				display.empty();

				$.each(images, function() {
					var image = this;

					display.append($.tmpl( "imageTemplate", image ));
				});

				if (videoMp4) {
					display.append(`<div class="product-detail-image__item product-detail-image__item--video">
						<video src="${videoMp4}" autoplay loop muted playsinline style="width: 100%;"></video>
					</div>`)
				}

				title.text(color);
				self.productDetailImageCarousel();
				self.productDetailZoom();
			};

			// Update thumbs
			var updateThumbs = function () {
				var display = container.find('[data-product-detail-thumb-display]'),
					list = container.find('[data-product-detail-thumb-list]');

				display.empty();

				list.children().clone().each(function () {
					var el = $(this),
						color = el.data('product-detail-thumb-color'),
						video = el.data('fancybox');

					if (color == value || typeof video !== 'undefined') {
						display.append(el);
					}
				});

				container.find('[data-product-detail-thumb-color]').first().addClass('product-detail-thumb__item--active');
			};

			// Update sizes
			var updateSizes = function (sizes, current_variant) {
				var display = container.find('[data-product-detail-size-display]'),
					stockContainer = container.find('.product-detail-inventory'),
					template = '<li class="product-detail-size__item{{if !available}} product-detail-size__item--disabled{{/if}}{{if id == current_variant}} active{{/if}}"\
									data-variant-price="${price}"\
									data-varitant-compared-price="${compare_at_price}"\
									data-product-variant-id="${id}"\
										{{if color}}data-product-variant-color="${color}"{{/if}}\
										{{if !available}}data-product-variant-disabled{{/if}}\
									>${size}</li>',
					stockTemplate = '<li class="product-detail-inventory__item{{if id == current_variant.id }} active{{/if}}"\
										data-inventory-variant-id="${id}"\
										data-inventory-variant-quantity="${inventory_quantity}"\
									>Only a few left in stock</li>';

				display.empty();
				stockContainer.empty()
				$.template('sizeTemplate', template);
				$.template('stockTemplate', stockTemplate);

				sizes.forEach(function(size) {
					size['current_variant'] = current_variant.id
					display.append($.tmpl('sizeTemplate', size));
					if(size.inventory_quantity > 0 && size.inventory_quantity < 5) {
						stockContainer.append($.tmpl('stockTemplate', size))
					}
				});
			};

			// Update stock notification
			var updateStock = function (active) {
				var active = active !== false ? active : container.find('[data-product-variant-type="size"]').find(':radio:checked'),
					variant = active.closest('[data-product-variant-id]'),
					variantId = variant.data('product-variant-id'),
					$quickshop = $('.quickshop--active'),
					isQuickshop = $quickshop.length > 0;

				if (isQuickshop) {
					const $addButtonText = $quickshop.find('[data-add-to-cart-text]');
					const variantInventory = $quickshop.find(`[data-variant-inventory] [data-variant-id="${variantId}"]`)
					const stock = parseFloat(variantInventory.data('inventory'))
					const available = variantInventory.data('available') === 'true'

					if (window.theme.preorderAppEnabled && available && stock < 1) {
						$addButtonText.html('Preorder now'); // TODO use app setting for this text

						// make sure the line item property input is there for preorder to work
						if ($quickshop.find('#preorder-note').length < 1) {
							$quickshop.find('form').append('<input type="hidden" id="preorder-note" name="properties[PN-Note]" value="Pre-order Item">')
						}
					} else {
						if ($quickshop.find('#preorder-note').length > 0) {
							$quickshop.find('#preorder-note').remove()
						}

						$addButtonText.html(theme.strings.addToCart);
					}
				}

				container.find('[data-inventory-variant-id]').removeClass('active');
				container.find('[data-inventory-variant-id="' + variantId + '"]').addClass('active');
			};

			var updateProductUrl = function (self) {
				var hasProducList = $(document).find('.product__list').length > 0;

				if (!hasProducList) return false;

				var variantId = $(self).parent().data('product-variant-id'),
						productLink = $(self).closest('[data-product]').find('.product__link'),
						oldHref = $(productLink).prop('href'),
						hasVariantInUrl = oldHref.indexOf('variant=') >= 0,
						priceElement = $(self).closest('[data-product]').find('.product-price'),
						price = $(self).data('price'),
						compared_at_price = $(self).data('compared-at-price'),
						newHref;

				if(compared_at_price && Number(price.replace('$', '')) < Number(compared_at_price.replace('$', ''))){
					priceElement.html('<span class="product-price__sale">'+ price +'</span><s class="product-price__original">' + compared_at_price + '</s>');
				} else {
					priceElement.html('<span class="product-price__regular">' + price + '</span>');
				}

				productLink.attr('href', $(self).prop('href'));
			};

			var updateQuickview = function(self) {
				var self = $(self);
				$.ajax({
					type: 'GET',
					url: '/products/' + self.parent().data('product-swatch-handle') + '?view=meta.json',
					success: function (result, textStatus, xhr) {
						try {
							var productMeta = JSON.parse(result);
							if (productMeta.hasOwnProperty('color_code')) productMeta.color_code = productMeta.color_code.replace(/ /g, '').toLowerCase()
							updateImages(productMeta.images, productMeta.color, productMeta.accentuate);
							updateSizes(productMeta.sizes, productMeta.current_variant);
						} catch (e) {
							return;
						}
					}
				})
			};

			// Update select on radio change
			el.find('.product-detail-color__item').on('click', '.product-swatches__link', function (e) {
				var active = el.find('li.active'),
					productId = $(this).data('product-id');

				value = el.data('color');
				select.val(value).change();

				//update quickview
				if(!$(this).parent().hasClass('active')) {
					updateQuickview(this);
				}

				active.removeClass('active');
				$(this).parent().addClass('active');


				if (type == 'color' || type == 'colour') {
					updateThumbs();
					updateStock(false);
					updatePDPMainImage(this);
					updateProductUrl(this);
				}

				// Check if were in a product tile and sync up the swatch inside the quickshop
				var $productTile = $(this).parent().parent().hasClass('product-detail-color__list--tile') ? $(this).closest('.product__item') : null;

				if (($productTile && $productTile.length > 0) && $productTile.find('[data-quickshop] a[data-product-id="' + productId +'"]')[0]) {
					$productTile.find('[data-quickshop] a[data-product-id="' + productId +'"]').click();
				}
				return false;
			});

			el.on('click', '.product-detail-size__item', function(){
				const $item = $(this);

				$item.addClass('active').siblings().removeClass('active');

				el.find('input[name="id"]').val($item.data('product-variant-id'));

				updateStock($item);

				$('[data-index-type="size"]').val($item.data('size')).change();
			});

		});
		//Update prices on search page
		$('.search__container').find('[data-product]').find('.product-detail-color__input:first').attr('checked', true).trigger('click').trigger('change');

		// Product Detail Thumbnails
		$(document).on('click', '[data-product-detail-thumb-color]', function () {
			var el = $(this),
				index = el.index(),
				container = el.closest('[data-product-detail]');

			container.find('[data-product-detail-image-display]').flickity('select', index);

			el.addClass('product-detail-thumb__item--active').siblings().removeClass('product-detail-thumb__item--active');

			// lazy load new slides video
			const $newSlide = container.find('.product-detail-image__item').eq(index)
			const $newSlideVideo = $newSlide.find('video[data-src]:not([src])')

			if ($newSlideVideo.length > 0) {
				$newSlideVideo.attr('src', $newSlideVideo.data('src'));
			}
		});
	},

	productVariants: function ($container) {
		// Product Detail Pairs With Variants (Size & Color)
		$container.find('[data-pairs-with-variant-type]').each(function () {
			var el = $(this),
				container = el.closest('[data-pairs-with]'),
				select = container.find('[data-product-select]'),
				selectedColor = container.find('input[name="selected-color"]'),
				selectedSize = container.find('input[name="selected-size"]'),
				pairsWithLink = container.find('.pairs-with__name-link'),
				value;

			// Update ID for add to cart & wishlist
			var updateId = function (data) {
				// update current variant id for add to cart
				container.find('[name="id"]').val(data.current_variant.id)

				// update wishlist id (only on swatch clicks, not on size clicks)
				if (data.hasOwnProperty('product_id')) {
					container.find('[data-product-id]').attr('data-product-id', data.product_id)
				}
			};

			var updateImage = function (images, color) {
				var display = container.find('[data-pairs-with-image-display]'),
					list = container.find('[data-pairs-with-image-list]'),
					title = container.find('[data-pairs-with-variant-title-color]'),
					image_template = '<img src="${image}" class="pairs-with-image__image" data-pairs-with-image-color="${alt}" alt="${alt}" />';

				$.template('imageTemplate', image_template);
				display.empty();
				display.append($.tmpl( "imageTemplate", images[0] ));
				title.text(color);
			};

			// Update prices
			var updatePrice = function (data) {
				/* data = {
						el: $priceContainer,
						elPrice: $priceText,
						elCompare:  $compareText,
						price: '$x.xx',
						priceCompare: '$x.xx' | ''
				} */

				data.elPrice.html(data.price)

				if (data.priceCompare !== '') {
					data.elContainer.addClass('discount')
					data.elCompare.html(data.priceCompare)
					data.elCompare.removeClass('hide')
				} else {
					data.elContainer.removeClass('discount')
					data.elCompare.addClass('hide')
					data.elCompare.html('')
				}
			}

			// Update sizes
			var updateSizes = function (sizes, current_variant) {
				var display = container.find('[data-pairs-with-size-display]'),
					stockContainer = container.find('.product-detail-inventory'),
					template = '<li class="product-detail-size__item{{if !available}} product-detail-size__item--disabled{{/if}}{{if id == current_variant}} active{{/if}}"\
									data-variant-price="${price}"\
									data-varitant-compared-price="${compare_at_price}"\
									data-product-variant-id="${id}"\
										{{if color}}data-product-variant-color="${color}"{{/if}}\
										{{if !available}}data-product-variant-disabled{{/if}}\
									>${size}</li>',
					stockTemplate = '<li class="product-detail-inventory__item{{if id == current_variant.id }} active{{/if}}"\
										data-inventory-variant-id="${id}"\
										data-inventory-variant-quantity="${inventory_quantity}"\
									>Only a few left in stock</li>';

				display.empty();
				stockContainer.empty()
				$.template('sizeTemplate', template);
				$.template('stockTemplate', stockTemplate);

				sizes.forEach(function(size) {
					size['current_variant'] = current_variant.id
					display.append($.tmpl('sizeTemplate', size));
					if(size.inventory_quantity > 0 && size.inventory_quantity < 5) {
						stockContainer.append($.tmpl('stockTemplate', size))
					}
				});
			};

			// Update stock notification
			var updateStock = function ($item) {
				container.find('[data-inventory-variant-id]').removeClass('active');
				container.find('[data-inventory-variant-id="' + $item.data('product-variant-id') + '"]').addClass('active');
			};

			var updateSelect = function () {
				select.find('option').each(function () {
					if (selectedColor.length || selectedSize.length) {
						if (selectedColor.length && selectedSize.length) {
							var arr = this.text.split('/'),
								colorValue = selectedColor.val(),
								sizeValue = selectedSize.val();

							if (($.trim(arr[0]) == sizeValue || $.trim(arr[0]) == colorValue) && ($.trim(arr[1]) == colorValue || $.trim(arr[1]) == sizeValue)) {
								select.val(this.value).change();
								return false;
							}
						} else {
							if (selectedSize.length) {
								if (this.text == selectedSize.val()) {
									select.val(this.value).change();
									return false;
								}
							}
							if (selectedColor.length) {
								if (this.text == selectedColor.val()) {
									select.val(this.value).change();
									return false;
								}
							}
						}
					}
				});
			}

			// Update title
			var updateTitle = function (data) {
				const title = data.title.split(' - ')[0]
				container.find('.pairs-with__name').text(title)
			};

			// Enable/Disable button
			var updateAvailability = function (active) {
				var container = active.closest('[data-pairs-with]'),
					availability = container.find('[data-availability]'),
					availabilityValue = availability.data('availability'),
					isPreorder = active.context.dataset.preorder === 'true'

				const preorderProperty = '<input type="hidden" id="preorder-note" name="properties[PN-Note]" value="Pre-order Item">'
				const $preorderProperty = container.find('#preorder-note')
				const hasPreorderProperty = $preorderProperty.length > 0

				if (availabilityValue) {
					var arr = availabilityValue.split(','),
						add = isPreorder ? 'Preorder now' : arr[0],
						out = arr[1],
						active = container.find('[data-pairs-with-variant-type="size"] :radio:checked');

					if (typeof active.context.dataset.productVariantDisabled !== 'undefined') {
						availability.find('span').text(out);
						availability.prop('disabled', true);
					} else {
						availability.find('span').text(add);
						availability.prop('disabled', false);

						if (hasPreorderProperty) {
							$preorderProperty.remove()
						}
					}
				}

				if (isPreorder && !hasPreorderProperty) {
					container.find('form').append(preorderProperty)
				}
			};

			el.find('.product-detail-color__item').on('click', '.product-swatches__link', function(){
				container.find('.product-detail-color__item').removeClass('active');

				var self = $(this);

				const $form = self.closest('[data-pairs-with-form]');

				const priceData = {
					elContainer: $form.find('.pairs-with__price'),
					elPrice: $form.find('[data-product-price]'),
					elCompare: $form.find('[data-compare-price]'),
					price: self.data('price'),
					priceCompare: self.data('compared-at-price'),
				};

				$.ajax({
					type: 'GET',
					url: '/products/' + self.parent().data('product-swatch-handle') + '?view=meta.json',
					success: function (result, textStatus, xhr) {
						try {
							self.parent().addClass('active');
							var productMeta = JSON.parse(result);
							updateId(productMeta);
							updateImage(productMeta.images, productMeta.color);
							updatePrice(priceData);
							updateSizes(productMeta.sizes, productMeta.current_variant);
							updateStock(container.find('.product-detail-size__item.active'))
							updateTitle(productMeta);
							pairsWithLink.attr('href', self.prop('href'));
						} catch (e) {
							return;
						}
					}
				})
				return false;
			});

			el.on('click', '.product-detail-size__item', function() {
				const $item = $(this)

				$item.addClass('active').siblings().removeClass('active');

				updateId({
					current_variant: {
						id: $item.data('product-variant-id')
					}
				});

				updateStock($item);
				updateAvailability($item);

				$item.closest('form').find('[data-product-select]').val($item.data('product-variant-id')).change()
			});

			// Update select on radio change
			el.find(':radio').on('change', function () {
				var active = el.find(':radio:checked'),
					type = el.data('pairs-with-variant-type');

				value = active.val();

				if (type == 'color' || type == 'colour') {
					selectedColor.val(value);
					updateSelect();
					updateImages();
					updateSizes();
					updateStock(false);
					updateAvailability(active);
				}

				if (type == 'size') {
					selectedSize.val(value);
					updateSelect();
					updateStock(active);
					updateAvailability(active);
				}
			});
		});
	},

	getBreakpoint: function () {
		var breakpoint;
		if (window.getComputedStyle) {
			breakpoint = window.getComputedStyle(
				document.querySelector('body'), ':before'
			).getPropertyValue('content');

			breakpoint = parseInt(breakpoint.replace("'", "").replace('"', ''));
		} else { // IE8 fallback
			breakpoint = $(window).width();
		}
		return breakpoint;
	},

	dataToggle: function (e) {
		var speed = 400,
			toggleData = e.data('toggle'),
			container = e.closest(':has(' + toggleData + ')');

		// Toggle siblings (if [data-siblings] is set)
		if (e.data('toggle-siblings')) {
			var siblings = e.closest(e.data('toggle-siblings')).siblings().find(toggleData);
			siblings.slideUp(speed).closest('.active-toggle').removeClass('active-toggle');
		}

		// Toggle element
		e.closest(container).toggleClass('active-toggle').find(toggleData).slideToggle(speed);
	},

	quickshopEvents: function () {
		var self = this;

		$('body').on('click', '[data-quickshop-btn]', function(e) {
			e.preventDefault();

			// Close if already open
			if ($(this).closest('.product__item').hasClass('product__item--quickshop-active')) {
				self.quickshopToggle(true)
				return false
			}

			self.quickshopContainer = $(this).closest('[data-product]');
			self.quickshopHandle = $(this).data('quickshop-btn');
			self.quickshopSelected = self.quickshopContainer.find('[data-quickshop]');

			const handle = self.quickshopSelected.data('handle')
			const id = self.quickshopSelected.data('current-variant-id')

			if (self.quickshopSelected.is(':empty')) {
				const quickShopButton = $(this)
				quickShopButton.text('Loading')

				$.ajax({
					type: 'GET',
					url: `/products/${handle}?variant=${id}&view=quickview`,
					success: (result, textStatus, xhr) => {
						// remove the " - colorname" from product title in markup
						let $markup = document.createElement('div')

						$markup = $($markup)

						$markup.html(result)

						const $productTitle = $markup.find('.product-detail__title')

						$productTitle.text($productTitle.text().split(' - ')[0])

						// add the updated markup
						self.quickshopSelected.html($markup.html())
						quickShopButton.text('Quick Shop')
						self.quickshopToggle();
					}
				})
			} else {
				self.quickshopToggle();
			}
		});

		$('body').on('click', '[data-quickshop-close]', function(e) {
			e.preventDefault()
			self.quickshopToggle(true)
		})
	},

	quickshopToggle: function (closeButtonClick) {
		var self = this;
		this.$openSiblings = $('.quickshop--active');

		// User clicked the 'X' button
		if (closeButtonClick) {
			this.$openSiblings.removeClass('quickshop--active');
			this.$openSiblings.closest('.product__item').removeClass('product__item--quickshop-active')
			this.$openSiblings.slideUp(function() {
				self.quickshopSelected.removeClass('quickshop--active');
				self.quickshopSelected.closest('.product__item').removeClass('product__item--quickshop-active');
			});

			return false
		}

		if (this.$openSiblings.length > 0) {
			self.productDetailImageCarousel();
			self.productSwatches();
			self.productUpdateInfo();

			self.productVariants(self.quickshopContainer);

			this.$openSiblings.toggleClass('quickshop--active');
			this.$openSiblings.closest('.product__item').toggleClass('product__item--quickshop-active')
			this.$openSiblings.slideToggle(function() {
				self.quickshopSelected.toggleClass('quickshop--active');
				self.quickshopSelected.closest('.product__item').toggleClass('product__item--quickshop-active');
				self.quickshopSelected.slideToggle(function() {
					$('[data-product-detail-image-display]').flickity('resize');
				});
			});
		} else {
			self.productDetailImageCarousel();
			self.productSwatches();
			self.productUpdateInfo();
			self.productVariants(self.quickshopContainer);

			this.quickshopSelected.closest('.product__item').toggleClass('product__item--quickshop-active')
			this.quickshopSelected.toggleClass('quickshop--active');
			this.quickshopSelected.slideToggle(function() {
				$('[data-product-detail-image-display]').flickity('resize');
				self.quickshopContainer.find('[data-product-detail-thumb-color]').first().addClass('product-detail-thumb__item--active');
			});
		}
	},

	addToMiniCart(self) {
		var self = self

		// No size selected show error
		if ($(self).find('[name="id"]').val() !== '') {
			this.minicart(null, $(self));
		}
	},

	minicart: function (item, form) {
		console.log(form)
		// Mini Cart
		var self = this,
				form = form || item.closest('form'),
				itemTemplate = $('[data-minicart-item-template]'),
				list = $('[data-minicart-list]'),
				template = $('[data-minicart-template]'),
				bongoTemplate = $('[data-minicart-bongo-item]');

		$.ajax({
			type: 'POST',
			url: '/cart/add.js',
			dataType: 'json',
			data: form.serialize(),
			success: function (result) {
				if (result) {
					var activeVariantId = $('[data-minicart-item-variant-id="' + result.variant_id + '"]'),
							activeColor = result.variant_options[0],
							activeSize = result.variant_options[1];

					// remove the " - colorname" from product title in markup
					result.product_title = result.product_title.split(' - ')[0]

					// Convert prices to currency
					result.price_converted = slate.Currency.formatMoney(result.price, theme.moneyFormat);
					result.original_price_converted = slate.Currency.formatMoney(result.original_price, theme.moneyFormat);
					result.product_color = activeColor;
					result.product_size = activeSize;

					// If sale price
					if (result.original_line_price != result.line_price) {
						result.price_converted = result.price_converted + ' <s>' + result.original_price_converted + '</s>';
					}

					if (result.properties && typeof result.properties['PN-Note'] !== 'undefined') {
						result.preorder_key = 'PN-Note';
						result.preorder_value = result.properties['PN-Note'];
					}

					if (list.length) {
						// If mini cart is not empty
						if (activeVariantId.length) {
							// If variant exists update quantity display
							activeVariantId.find('[data-minicart-item-count]').text(result.quantity);
							// If variant exists update hidden quantity field
							activeVariantId.find('[data-input-quantity]').val(result.quantity);
							$('[data-minicart-item-variant-id="' + result.variant_id + '"]').val(result.quantity);
						} else {
							// If variant does not exists insert item template
							itemTemplate.tmpl(result).prependTo('[data-minicart-list]');

							result.index = $('.mini-cart__item').length;

							bongoTemplate.tmpl(result).appendTo('[name="BongoCheckoutForm"]');

							var total = result.quantity * result.price
							$('[data-minicart-item-variant-id="' + result.variant_id + '"]').attr('data-minicart-item-total', total);
						}
					} else {
						// If mini cart is empty insert template
						template.tmpl(result).appendTo('[data-minicart]');
						result.index = $('.mini-cart__item').length;
						bongoTemplate.tmpl(result).appendTo('[name="BongoCheckoutForm"]');

						var total = result.quantity * result.price
						$('[data-minicart-item-variant-id="' + result.variant_id + '"]').attr('data-minicart-item-total', total);
					}

					$('[data-minicart-empty]').addClass('hidden')
					$('[data-minicart-full]').removeClass('hidden')

					self.setCartCount();
					self.setSubtotal();
					self.toggleFreeShippingMessage();

					self.sidebarType = 'cart';
					if (!self.$page.hasClass('sidebar-' + self.sidebarType + '--active')) {
						self.sidebarToggle();
					}
				}
			},
			error: function (jqXHR, exception) {
				var msg;

				if (jqXHR.status === 0) {
					msg = 'Not connect.\n Verify Network.';
				} else if (jqXHR.status == 404) {
					msg = 'Requested page not found. [404]';
				} else if (jqXHR.status == 500) {
					msg = 'Internal Server Error [500].';
				} else if (exception === 'parsererror') {
					msg = 'Requested JSON parse failed.';
				} else if (exception === 'timeout') {
					msg = 'Time out error.';
				} else if (exception === 'abort') {
					msg = 'Ajax request aborted.';
				} else {
					msg = 'Uncaught Error.\n' + jqXHR.responseText;
				}

				alert(msg);
			}
		});

		return false;
	},

	sidebarTrigger: function () {
		var self = this;

		self.$page.on('click', '[data-sidebar]', function(e) {
			e.preventDefault();

			self.sidebarType = $(this).data('sidebar');
			self.sidebarToggle();
		});
	},

	sidebarToggle: function () {
		var self = this;
		this.$page.toggleClass('sidebar-' + self.sidebarType + '--active');
		this.$page.find('[data-sidebar-backdrop="'+ self.sidebarType + '"]').toggleClass('backdrop--active')

		if (this.$page.hasClass('sidebar-cart--active')) {
			$('.sidebar__close').attr('tabindex', '0')
			$('.sidebar__close').focus()
		} else {
			$('.sidebar__close').attr('tabindex', '-1')
		}
	},

	setCartCount: function(items) {
		var cartItems = typeof items !== 'undefined' ? items : document.querySelectorAll('[data-minicart-item-variant-id]')
		this.cartCount = 0;

		cartItems.forEach((el, i) => {
			var itemCount = parseFloat(el.querySelector('[data-input-quantity]').value);
			this.cartCount += itemCount;
		})

		// Update header cart count
		if (this.headerCartCount.length) this.headerCartCount.text(this.cartCount);
	},

	setSubtotal: function () {
		this.free_shipping.subtotal = 0;

		document.querySelectorAll('[data-minicart-item-total]').forEach((el, i) => {
			this.free_shipping.subtotal += parseFloat(el.dataset.minicartItemTotal);
		});

		$('[data-minicart-subtotal]').text(slate.Currency.formatMoney(this.free_shipping.subtotal, theme.moneyFormat));
	},

	toggleFreeShippingMessage: function() {
		// Handle shipping promo
		if (this.free_shipping.amount > 0 && this.free_shipping.subtotal < this.free_shipping.amount) {
			var difference = this.free_shipping.amount - this.free_shipping.subtotal;
			var ratio = (this.free_shipping.subtotal / this.free_shipping.amount * 100) + '%';

			$('[data-free-shipping-active]').hide();
			$('[data-free-shipping-promo]').show();

			$('[data-minicart-promo-difference]').text('You\'re only ' + slate.Currency.formatMoney(difference, theme.moneyFormat) + ' from Free US Shipping');
		} else {
			$('[data-free-shipping-active]').show();
			$('[data-free-shipping-promo]').hide();
		}
	},

	navAccessibility: function () {
		var topLevelLinks = $('.header-nav > ul').find('> li > a')

		var settings = {
			menuHoverClass: 'show-menu'
		}

		$(topLevelLinks).focus(function() {
			$('.header-nav [aria-hidden="false"]')
				.attr('aria-hidden', 'true')
				.removeClass(settings.menuHoverClass)
				.find('[aria-hidden="false"]')
				.attr('tabIndex', -1)
				.attr('aria-hidden', 'true')

			$(this)
				.next('[aria-hidden="true"]')
				.attr('aria-hidden', 'false')
				.addClass(settings.menuHoverClass)
				.find('a')
				.attr('tabIndex', 0)
				.attr('aria-hidden', 'false')
		})

		// Hide menu if click or focus occurs outside of navigation
		$('.header-nav > ul')
			.find('a')
			.last()
			.keydown(function(e) {
					if (e.keyCode == 9) {
							// If the user tabs out of the navigation hide all menus
							$('.' + settings.menuHoverClass)
									.attr('aria-hidden', 'true')
									.removeClass(settings.menuHoverClass)
									.find('[aria-hidden="false"]')
									.attr('aria-hidden', 'true')
									.attr('tabIndex', -1)
					}
			})

		$(document).click(function() {
			$('.' + settings.menuHoverClass)
					.attr('aria-hidden', 'true')
					.removeClass(settings.menuHoverClass)
					.find('[aria-hidden="false"]')
					.attr('aria-hidden', 'true')
					.attr('tabIndex', -1)
		})
	},

	productHoverVideos() {
		$(document).on('mouseenter', '[data-alternate-image]', function () {
			const videoHover = $(this).find('video')
			if (videoHover.length > 0 && (!videoHover.attr('src') || videoHover.attr('src') === 'javascript:void(0)' || videoHover.attr('src') === '#')) {
				videoHover.attr('src', videoHover.data('src'))
				videoHover[0].load()
				videoHover[0].play()
			}
		});

		$(document).on('mouseleave', '[data-alternate-image]', function () {
			const videoHover = $(this).find('video')
			if (videoHover.length > 0 && videoHover.attr('data-src')) {
				videoHover.removeAttr('src')
			}
		});
	}
};

$(function () {
	base.init();

	window.lazy = new LazyLoad({
		elements_selector: '.lazy',
		LoadMode: 1, // 0 -> don't load anything | 1 -> Only load visible els | 2 -> Load also very near view els | 4 -> Load also not so near view els
		threshold: -50
	});




});